const $ = jQuery.noConflict();

class Tooltip {
	constructor() {
		this.tooltips = $('.component-tooltip');
		this.tooltipClose = $('.component-tooltip__close');
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.tooltips.on('click', this.openTooltip);
		this.tooltipClose.on('click', this.closeTooltip);
	}
	openTooltip(e) {
		e.preventDefault();
		if (!$(e.target).hasClass('component-tooltip__close') && !$(e.target).hasClass('open')) {
			$('.component-tooltip').removeClass('open');
			$('.component-tooltip__content').attr('aria-hidden', true);
			const tooltipBlock = $(this).closest('.component-tooltip');

			tooltipBlock
				.addClass('open');
			
			const tooltipContent = tooltipBlock.find('.component-tooltip__content');

			if (tooltipContent) {
				tooltipContent.attr('aria-hidden', false);
				tooltipContent.removeAttr('style');
			}
		} else {
			$('.component-tooltip').removeClass('open');
			$('.component-tooltip__content').attr('aria-hidden', true);
		}
	}
	closeTooltip() {
		const tooltipBlock = $(this).closest('.component-tooltip');

		tooltipBlock
			.removeClass('open');
		tooltipBlock
			.find('.component-tooltip__content')
			.attr('aria-hidden', true);
	}
}

const newTooltip = new Tooltip();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newTooltip.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
